export default "__VITE_ASSET__3fKiLg3G__"